export default "<app-service-provider-list></app-service-provider-list>\r\n";